// Main Product

document.addEventListener('DOMContentLoaded', function() {
  function updateOnClickAttribute() {
    const mediaElements = document.querySelectorAll('.product-gallery__media');
    const screenWidth = window.innerWidth;

    mediaElements.forEach(element => {
      const mediaLayout = element.getAttribute('data-media-layout');

      const shouldAddOnClick = (screenWidth < 1000) || (screenWidth >= 1000 && mediaLayout && mediaLayout.includes('grid'));

      if (shouldAddOnClick) {
        element.setAttribute('onclick', 'triggerZoom(this)');
      } else {
        element.removeAttribute('onclick');
      }
    });
  }

  updateOnClickAttribute();

  window.addEventListener('resize', updateOnClickAttribute);
});

const triggerZoom = $this => {

  if($this.querySelector("[is='product-zoom-button']")){
    $this.querySelector("[is='product-zoom-button']").click();
  }
  
};


document.addEventListener("DOMContentLoaded", () => {
    const newStockElement = document.getElementById("new-stock");

    if (newStockElement) {
        newStockElement.style.display = "none";

        const checkForDisabledClass = () => {
            if (document.querySelector(".block-swatch.is-disabled") || 
                document.querySelector(".popover-listbox__option.is-disabled")
            ) {
                newStockElement.style.display = "block";
            } else {
                newStockElement.style.display = "none";
            }
        };

        checkForDisabledClass();

        const observer = new MutationObserver(checkForDisabledClass);
        observer.observe(document.body, { childList: true, subtree: true });
    }
});


document.addEventListener("DOMContentLoaded", () => {
  const variantOptions = document.querySelectorAll("[data-option-value]");

  variantOptions.forEach((option) => {
    option.addEventListener("click", (event) => {
      if (option.classList.contains("is-disabled")) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    });
  });
});


// Navigation

document.addEventListener("DOMContentLoaded", function() {
  var navigationSection = document.querySelector('.shopify-section.shopify-section--navigation');
  
  if (navigationSection) {
    navigationSection.setAttribute('hide-on-scroll', '100');
    
    if (typeof stickyFalse !== 'undefined' && stickyFalse) {
      navigationSection.setAttribute('sticky', 'false');
    }

    if (typeof stickyTrue !== 'undefined' && stickyTrue) {
      navigationSection.setAttribute('sticky', 'true');
    }
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const navigationSection = document.querySelector(".shopify-section.shopify-section--navigation");

  if (!navigationSection) return;

  const stickyAttribute = navigationSection.getAttribute("sticky");

  const hideOnScrollThreshold = parseInt(navigationSection.getAttribute("hide-on-scroll"));
  let lastScrollTop = 0;
  let accumulatedScroll = 0;

  const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
  const borderNavigation = getComputedStyle(navigationSection).getPropertyValue('--border-navigation');

  const updateNavigationPosition = () => {
    if (window.scrollY < 0) return;

    if (window.scrollY > lastScrollTop) {
      accumulatedScroll = Math.max(0, accumulatedScroll + (window.scrollY - lastScrollTop));

      if (accumulatedScroll > hideOnScrollThreshold) {
        navigationSection.style.top = `calc(-${borderNavigation})`;
        navigationSection.style.zIndex = '11';
      }
    } else if (window.scrollY < lastScrollTop) {
      accumulatedScroll = 0;

      navigationSection.style.top = `calc(-${borderNavigation} + ${headerHeight}px)`;
      navigationSection.style.zIndex = '9';
    }

    lastScrollTop = window.scrollY <= 0 ? 0 : window.scrollY;
  };

  if (stickyAttribute === "true") {
    navigationSection.style.top = `calc(-${borderNavigation})`;
    navigationSection.style.zIndex = '11';
  }
  else if (stickyAttribute === "false") {
    navigationSection.style.top = `calc(-${borderNavigation} + ${headerHeight}px)`;
    navigationSection.style.zIndex = '9';
  }
  else {
    window.addEventListener("scroll", () => {
      updateNavigationPosition();
    });

    updateNavigationPosition();
  }
});


// Footer

function initAccordion() {
  if (window.innerWidth <= 1000) {
    document.querySelectorAll("[data-toggle]").forEach(toggle => {
      toggle.removeEventListener("click", toggleAccordion);
      toggle.addEventListener("click", toggleAccordion);
    });
  }
}

function toggleAccordion() {
  const menu = this.nextElementSibling;

  if (!menu) return;

  const isOpen = menu.style.maxHeight && menu.style.maxHeight !== "0px";

  if (isOpen) {
    menu.style.maxHeight = `${menu.scrollHeight}px`;
    setTimeout(() => {
      menu.style.maxHeight = "0";
      menu.style.opacity = "0";
      menu.style.visibility = "hidden";
    }, 10);
    this.classList.remove("open");
  } else {
    menu.style.maxHeight = "0";
    menu.style.opacity = "0";
    menu.style.visibility = "hidden";

    setTimeout(() => {
      menu.style.maxHeight = `${menu.scrollHeight}px`;
      menu.style.opacity = "1";
      menu.style.visibility = "visible";
    }, 10);
    this.classList.add("open");
  }
}

document.addEventListener("DOMContentLoaded", initAccordion);

document.addEventListener("shopify:section:load", initAccordion);

window.addEventListener("resize", function () {
  document.querySelectorAll("[data-toggle]").forEach(toggle => {
    toggle.removeEventListener("click", toggleAccordion);
  });
  initAccordion();
});


// Social proof

document.addEventListener("DOMContentLoaded", function() {
  const socialProof = document.querySelector('.social-proof');
  const socialProofContainer = document.querySelector('.social-proof-container');
  const complementarySpan = document.querySelector('.complementary-text span');
  const excessSpan = document.querySelector('.excess-text');

  function adjustText() {
    if (!socialProof || !socialProofContainer || !complementarySpan || !excessSpan) return;
    
    const fullText = complementarySpan.dataset.fullText || complementarySpan.textContent;
    complementarySpan.dataset.fullText = fullText;
    
    const words = fullText.split(' ');
    
    const availableWidth = socialProof.getBoundingClientRect().width - 
                            socialProofContainer.getBoundingClientRect().width;

    const tempSpan = document.createElement('span');
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.fontSize = window.getComputedStyle(complementarySpan).fontSize;
    tempSpan.style.fontFamily = window.getComputedStyle(complementarySpan).fontFamily;
    tempSpan.style.letterSpacing = window.getComputedStyle(complementarySpan).letterSpacing;
    tempSpan.style.fontWeight = window.getComputedStyle(complementarySpan).fontWeight;
    document.body.appendChild(tempSpan);

    let fitText = "";
    let overflowText = "";

    for (let i = 0; i < words.length; i++) {
      const testText = fitText === "" ? words[i] : fitText + " " + words[i];
      tempSpan.textContent = testText;
      
      if (tempSpan.getBoundingClientRect().width < availableWidth) {
        fitText = testText;
      } else {
        overflowText = words.slice(i).join(" ");
        break;
      }
    }

    complementarySpan.textContent = fitText;
    excessSpan.textContent = overflowText;
    
    document.body.removeChild(tempSpan);
  }

  adjustText();
  window.addEventListener('resize', adjustText);
});